<template>
  <div>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'guest-view',
  data() {
    return {
    };
  },
};
</script>
